import { useEffect } from 'react';

type HotkeyHandler = (e: KeyboardEvent) => void;

interface HotkeyConfig {
  key: string;
  ctrlKey?: boolean;
  metaKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  handler: HotkeyHandler;
}

export const useHotkeys = (configs: HotkeyConfig[]) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      for (const config of configs) {
        const matchesKey = e.key.toLowerCase() === config.key.toLowerCase();
        const matchesModifiers = 
          (config.ctrlKey === undefined || e.ctrlKey === config.ctrlKey) &&
          (config.metaKey === undefined || e.metaKey === config.metaKey) &&
          (config.shiftKey === undefined || e.shiftKey === config.shiftKey) &&
          (config.altKey === undefined || e.altKey === config.altKey);

        if (matchesKey && matchesModifiers) {
          e.preventDefault();
          config.handler(e);
          break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [configs]);
};

// Common hotkey configurations
export const HOTKEYS = {
  POST: {
    key: 'Enter',
    metaKey: true,
  },
} as const; 